import { defineStore } from 'pinia'
import { BaseMessage } from '~/utils/baseMessage'

/**
 * @description 产品对比（PK）存储
 */
export const useStoreCompareStore = defineStore('storeCompare', {
  state: () => ({
    /** @type {Array} 对比商品列表 */
    items: [],
    /** @type {number} 最大对比数量 */
    maxItems: 4,
  }),
  getters: {
    /**
     * @description 对比商品总数
     */
    count: (state) => state.items.length,
    /**
     * @description 判断对比列表是否已满
     */
    isFull: (state) => state.items.length >= state.maxItems,
    /**
     * @description 判断商品是否已在对比列表中
     */
    isInCompare: (state) => (productId) =>
      state.items.some((item) => (item.prodId || item.id) === productId),
  },
  actions: {
    /**
     * @description 切换对比状态
     * @param {Object} product - 产品信息
     */
    toggleCompare(product) {
      const prodId = product.prodId || product.id
      const index = this.items.findIndex((item) => (item.prodId || item.id) === prodId)
      if (index > -1) {
        this.items.splice(index, 1)
      } else {
        if (this.items.length >= this.maxItems) {
          BaseMessage.warning(`最多只能对比 ${this.maxItems} 台商品`)
          return
        }
        this.items.push(product)
      }
    },
    /**
     * @description 从对比列表移除商品
     * @param {number|string} productId - 产品 ID
     */
    removeFromCompare(productId) {
      this.items = this.items.filter((item) => (item.prodId || item.id) !== productId)
    },
    /**
     * @description 清空对比列表
     */
    clearCompare() {
      this.items = []
    },

    /**
     * @description 清除对比本地状态（别名，保持一致性）
     */
    clearCompareState() {
      this.clearCompare()
    },
  },
})
